const banner = `
███████╗ █████╗ ███████╗██╗   ██╗██╗  ██╗██╗██████╗ ███████╗     █████╗ ██╗
██╔════╝██╔══██╗██╔════╝╚██╗ ██╔╝██║  ██║██║██╔══██╗██╔════╝    ██╔══██╗██║
█████╗  ███████║███████╗ ╚████╔╝ ███████║██║██████╔╝█████╗      ███████║██║
██╔══╝  ██╔══██║╚════██║  ╚██╔╝  ██╔══██║██║██╔══██╗██╔══╝      ██╔══██║██║
███████╗██║  ██║███████║   ██║   ██║  ██║██║██║  ██║███████╗    ██║  ██║██║
╚══════╝╚═╝  ╚═╝╚══════╝   ╚═╝   ╚═╝  ╚═╝╚═╝╚═╝  ╚═╝╚══════╝    ╚═╝  ╚═╝╚═╝
`

export function printConsoleBanner() {
  console.info(
    `%c${banner}%cEasyHire AI  %chttps://easyhireai.com`,
    'color: #60a5fa; text-shadow: 1px 1px 0 #2563eb; font-family: Consolas, "Lucida Console", "Courier New", monospace; font-size: 12px; line-height: 1; font-weight: normal;',
    'color: #60a5fa; font-family: Consolas, "Courier New", monospace; font-weight: bold;',
    'color: #38bdf8; font-family: monospace; text-decoration: underline;',
  )
}
